import angular from 'angular';
import CSMCommonWeb from 'csm-common-web';
import groupMembers from '../../../../com/groupMembers/groupMembers';
import addChangeGroupDialogTemplate from '../../templates/AddChangeGroupDialog.template.html';

export default angular
  .module('entitiesAdmin.dialogs.AddChangeGroupDialog', [
    CSMCommonWeb,
    groupMembers
  ])
  .service('AddChangeGroupDialog', Service)
  .name;

/*******************************************************************************
 * Service: AddChangeGroupDialog
 *
 * This dialog serves the purpose of managing entities of the group type or to
 * just manage a list of members for the passed in group. This dialog will load
 * the group information if the <b>groupID</b> property is not 0, otherwise it
 * will set up a new <b>Group</b> object to work with.
 *
 * When using this dialog to handle a list of members only, it can take an Array
 * of <b>GroupMember</b> objects to have as the starting list if this is for a
 * new group. Otherwise, the list of members will be loaded from the entity
 * object.
 *******************************************************************************/
/* @ngInject */ function Service($uibModal) {
  /****************************************************************************
   * show */
  /**
   * Show the modal dialog for adding/changing groups.
   *
   * @param   membersOnly    Flag to indicate that only the members will be worked
   *                         with. When this is true, no saving will be done in
   *                         the panel.
   * @param   showTitle      Flag to indicate if the title column should be
   *                         displayed in the grid of <b>GroupMember</b> objects.
   * @param   groupID        ID of the group to load/manage. 0=New Group.
   * @param   groupType      If set, only allows for the set type group to be
   *                         added/changed.
   * @param   saveGroup      Flag to save Group. If false, the group info will not
   *                         be saved, but instead the dialog will be closed and
   *                         the members returned.
   * @param   entityList     The list of objects that are available to be members.
   *                         As we have several entity class types for reading,
   *                         the object must the Name, StudentID, and ID properties
   *                         for use in this component.
   * @return                 Promise that resolves when the modal dialog is closed.
   ****************************************************************************/
  this.show = function (
    membersOnly,
    showTitle,
    groupID,
    groupType,
    saveGroup,
    entityList
  ) {
    return $uibModal.open({
      animation: true,
      backdrop: 'static',
      controller: AddChangeGroupDialogController,
      size: 'md',
      resolve: {
        membersOnly: function () {
          return membersOnly;
        },
        showTitle: function () {
          return showTitle;
        },
        groupID: function () {
          return groupID;
        },
        groupType: function () {
          return groupType;
        },
        saveGroup: function () {
          return saveGroup;
        },
        entityList: function () {
          return Array.isArray(entityList) ? entityList.concat() : [];
        }
      },
      template: addChangeGroupDialogTemplate
    }).result;
  };
}

/** Dialog Controller. */
/* @ngInject */
function AddChangeGroupDialogController(
  $scope,
  $q,
  SERVER,
  BooksSvc,
  BusyScreen,
  GroupsSvc,
  entityList,
  groupID,
  groupType,
  membersOnly,
  saveGroup
) {
  /*****************************************************************************
   * Properties
   *****************************************************************************/
  /** Members Only flag. */ $scope.membersOnly = membersOnly;
  /** New Group Flag. */ $scope.newGroup = !Number(groupID);
  /** Validator object. */ $scope.valGroup = {};

  var mGroupType = groupType || SERVER.BooksDBConstants.ET_GROUP;

  /***************************************************************************
   * handleCommit */
  /**
   * Handles the Adding/Removing of members
   ***************************************************************************/
  $scope.handleCommit = function () {
    /*--------------------------*/
    /* Validation failed, exit. */
    /*--------------------------*/
    if (!$scope.valGroup.validate()) return;

    /*---------------------------------------*/
    /* If the saveGroup flag is true, save   */
    /* the group with a call to the service. */
    /*---------------------------------------*/
    if (saveGroup) {
      BusyScreen.setBusy(true);
      BooksSvc.saveGroup(mGroupType, $scope.group)
        .then(function (resp) {
          $scope.$close(resp.data);
        })
        .finally(function () {
          BusyScreen.setBusy(false);
        });
    } else $scope.$close($scope.group);

    /*--------------------------------------------*/
    /* Otherwise, close the dialog with the group */
    /* information to be handled at a parent.     */
    /*--------------------------------------------*/
  };

  /***************************************************************************
   * init */
  /**
   * Setup the dialog. Load group data if group ID is available.
   ***************************************************************************/
  function init() {
    $scope.entityList = entityList;

    /*------------------------------------------------------*/
    /* Load the group object if this component isn't in the */
    /* membersOnly mode and a group ID has been provided.   */
    /*------------------------------------------------------*/
    BusyScreen.promise(
      $q
        .when(
          !$scope.newGroup && !membersOnly
            ? GroupsSvc.get(groupID, mGroupType).then((r) => r.data)
            : {
                active: true,
                type: mGroupType,
                name: '',
                notes: '',
                members: []
              }
        )
        .then(function (group) {
          $scope.group = group;

          /*-----------------------*/
          /* Set the dialog title. */
          /*-----------------------*/
          $scope.dialogTitle = $scope.newGroup
            ? 'Adding New Group'
            : 'Changing ' + $scope.group.name;
        })
    );
  }

  /*--------------------*/
  /* Initialize dialog. */
  /*--------------------*/
  init();
}
